import { render, staticRenderFns } from "./ReportsCreateView.vue?vue&type=template&id=4b23ee8e&"
import script from "./ReportsCreateView.vue?vue&type=script&lang=ts&"
export * from "./ReportsCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b23ee8e')) {
      api.createRecord('4b23ee8e', component.options)
    } else {
      api.reload('4b23ee8e', component.options)
    }
    module.hot.accept("./ReportsCreateView.vue?vue&type=template&id=4b23ee8e&", function () {
      api.rerender('4b23ee8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/reports/ReportsCreateView.vue"
export default component.exports